import { defineMessage } from 'services/localization';

export const messages = {
    nameColumnName: defineMessage('name'),
    dateColumnName: defineMessage('date'),
    dueDateColumnName: defineMessage('due_date'),
    plannedDateColumnName: defineMessage('planned_date'),
    currentColumnName: defineMessage('current'),
    lessThanOneMonthColumnName: defineMessage('month_2'),
    oneMonthColumnName: defineMessage('month'),
    twoMonthsColumnName: defineMessage('months_2'),
    threeMonthsColumnName: defineMessage('months_3'),
    olderColumnName: defineMessage('older'),
    amountDueColumnName: defineMessage('amount_due'),
};
